import { useParams } from 'react-router-dom'
import ClientIdentityForm from './ClientIdentityForm'

const View = () => {
    const params = useParams()

    return (
        <ClientIdentityForm
            id={parseInt(params.clientIdentityId)}
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Brand identity updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update brand identity',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating brand identity...',
                },
            }}
        />
    )
}

export default View
